import { Card, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Talon.scss';
import { useTranslation } from 'react-i18next';
import { ResourcesSVG } from 'src/Member/img/GlobalSVG';

function Talon() {
  const { t } = useTranslation();

  return (
    <Col className="col-md-4 margin-bottom-32">
      <Card className="talon-container">
        <div className="talon-top-heading">
          <div className="talon-title">{t('member.dashboard.talon.title')}</div>

          <Link to="/member/cost-estimator" aria-label="find a provider">
            <ResourcesSVG.ExternalLinkSVG className="fill-color talon-icon" />
            <span className="talon-click"> Click here</span>
          </Link>
          <span className="talon-desc">
            {t('member.dashboard.talon.description')}
          </span>
        </div>
      </Card>
    </Col>
  );
}

export default Talon;
